import { TeacherManagementFormPage } from './TeacherManagementFormPage';
export default TeacherManagementFormPage;
